var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"hidden"}},[_c('TopNavBar2',{staticClass:"tnb2"}),_c('form1',{staticClass:"contact-mt"}),_c('Footer1')],1)}
var staticRenderFns = []

export { render, staticRenderFns }